const getTextFormFieldObj = ({
    label,
    htmlName,
    required,
    span,
    maxLength,
    validations,
}) => ({
    type: 'text',
    label,
    name: htmlName,
    required,
    span,
    maxLength,
    validations,
});

const getEmailFormFieldObj = ({
    label,
    htmlName,
    required,
    span,
    maxLength,
    validations,
}) => ({
    type: 'email',
    label,
    name: htmlName,
    required,
    span,
    maxLength,
    validations,
});

const getNumberFormFieldObj = ({
    label,
    htmlName,
    required,
    span,
    maxLength,
    validations,
}) => ({
    type: 'number',
    label,
    name: htmlName,
    required,
    span,
    maxLength,
    validations,
});

const getDropdownFormFieldObj = ({
    label,
    htmlName,
    required,
    span,
    options,
    placeholder,
    validations,
}) => ({
    type: 'dropdown',
    label,
    name: htmlName,
    span,
    required,
    options,
    placeholder,
    validations,
});

const getCheckboxFormFieldObj = ({
    label,
    supportingText,
    htmlName,
    span,
    required,
    validations,
}) => ({
    type: 'checkbox',
    label,
    supportingText,
    name: htmlName,
    span,
    required,
    validations,
});

export {
    getTextFormFieldObj,
    getEmailFormFieldObj,
    getNumberFormFieldObj,
    getDropdownFormFieldObj,
    getCheckboxFormFieldObj,
};
